import { useEffect, useCallback, useState } from "react";
import axios from "axios";

// Import de Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchData } from "../Hooks/useFetchData";
import { useBonusPrice } from "../Hooks/useBonusPrice";

// Import de Navbar
import { UserNavbar } from "../Components/UserNavbar";

// Importaciones para Loadings
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import de Iconos
import {
  FaUserPlus,
  FaGift,
  FaStar,
  FaTrophy,
  FaInfoCircle,
} from "react-icons/fa";

function Referidos() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const { aux } = useBonusPrice(accessToken.access_token);

  //User data
  const { user } = useFetchData(accessToken.access_token);
  const [referralInfo, setReferralInfo] = useState([]);
  const [referralBonus, setReferralBonus] = useState([]);

  // States
  const [copiado, setCopiado] = useState(false);
  const [showModal, setShowModal] = useState(false); // Nuevo estado para el modal
  const [loading, setLoading] = useState(false);
  const [modalRedeem, setModalRedeem] = useState(false);
  const [selectedPoints, setSelectedPoints] = useState(0);

  // Función para alternar el modal de canje
  const toggleModalRedeem = (point, amount) => {
    setModalRedeem(!modalRedeem);
    setSelectedPoints(point);
  };

  // Función para manejar el canje de puntos
  const handleSubmit = async () => {
    setLoading(true);

    try {
      await axios.post(
        `${url}/PointRedemption/redeemOrCreate`,
        {
          pr_userId: user?.use_id,
          pr_pointsUsed: selectedPoints,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  const fetchReferralInfo = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Users/referredBy/${user?.use_referrerCode}`,
        {
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }
      );
      setReferralInfo(response.data);
    } catch (error) {
      console.error("Error fetching referral info:", error);
      return [];
    }
  }, [url, user?.use_referrerCode, accessToken.access_token]);

  const fetchReferralBonus = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/ReferralBonus/referrer/${user?.use_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }
      );
      setReferralBonus(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching referral info:", error);
      return [];
    }
  }, [url, user?.use_id, accessToken.access_token]);

  useEffect(() => {
    if (user) {
      fetchReferralInfo();
      fetchReferralBonus();
    }
  }, [user, fetchReferralInfo, fetchReferralBonus]);

  return (
    <div className="referidos-page">
      {modalRedeem && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem 2.5rem",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "300px",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                color: "#ff9800",
                marginBottom: "1rem",
              }}
            >
              ⚠️
            </div>
            <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
              ¡Advertencia!
            </div>
            <div>Estas acciones no se pueden deshacer.</div>
            <button
              style={{
                marginTop: "1.5rem",
                marginRight: "1rem",
                padding: "0.5rem 1.5rem",
                borderRadius: "8px",
                border: "none",
                background: "#2a9d8f",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={async () => {
                await handleSubmit();
                setModalRedeem(false);
              }}
              disabled={loading}
            >
              {loading ? "Canjeando..." : "Canjear"}
            </button>
            <button
              style={{
                marginTop: "1.5rem",
                padding: "0.5rem 1.5rem",
                borderRadius: "8px",
                border: "none",
                background: "#ff9800",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => setModalRedeem(false)}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Encabezado */}
      <div className="referidos-header">
        <div className="header-text">
          <h2>
            <FaStar /> Referidos
          </h2>
          <p>Gana puntos invitando amigos a nuestra plataforma.</p>
        </div>
        <a
          className="invite-btn"
          href={`https://wa.me/?text=${encodeURIComponent(
            `¡Únete a la plataforma! Aquí tienes mi link de invitación: https://remesaespana.com/Register/${user?.use_referrerCode}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaUserPlus /> Invitar por WhatsApp
        </a>
      </div>

      {/* Enlace de invitación */}
      <div className="referral-code-card">
        <h3>Tu enlace de invitación</h3>

        {/* ALERTA VISUAL SI EL USUARIO NO ESTÁ VERIFICADO */}
        {(user?.use_verif === "N" || user?.use_verif === "E") && (
          <div
            style={{
              background: "#fff3cd",
              color: "#856404",
              border: "1px solid #ffeeba",
              borderRadius: "12px",
              padding: "1rem",
              marginBottom: "1rem",
              textAlign: "center",
              fontFamily: "Inter, sans-serif",
            }}
          >
            ⚠️ Necesitas verificarte para obtener tu enlace de referido.
            <br />
            <button
              onClick={() => (window.location.href = "/changes")}
              style={{
                marginTop: "0.8rem",
                padding: "0.5rem 1.2rem",
                background: "#2a9d8f",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Verifícate ahora
            </button>
          </div>
        )}

        <div className="referral-info">
          <div className="code">
            Código:{" "}
            <strong>
              {user?.use_referrerCode || <Skeleton width={100} />}
            </strong>
          </div>
          <div className="link">
            <input
              type="text"
              readOnly
              value={`https://remesaespana.com/Register/${user?.use_referrerCode}`}
            />
            <button
              onClick={() => {
                navigator.clipboard.writeText(
                  `https://remesaespana.com/Register/${user?.use_referrerCode}`
                );
                setCopiado(true);
                setTimeout(() => setCopiado(false), 2000);
              }}
            >
              {copiado ? "Copiado" : "Copiar"}
            </button>
          </div>
        </div>
      </div>

      {/* Resumen de puntos */}
      <div className="points-summary">
        <div className="points-card">
          <FaGift className="icon" />
          <div>
            <h4>Euros obtenidos (Referidos)</h4>
            <p>
              {referralBonus.reduce((acc, bonus) => acc + bonus.amount, 0)} €
            </p>
          </div>
        </div>
        <div className="points-card">
          <FaStar className="icon" />
          <div>
            <h4>Puntos de lealtad</h4>
            <p>{user?.use_loyaltyPoints || 0}</p>
          </div>
        </div>
        <button className="level-button" onClick={() => setShowModal(true)}>
          <FaTrophy className="icon-btn" />
          Canjear puntos
        </button>
      </div>

      {/* Modal de puntos */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div
            className="modal-content modal-referidos"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Canjea tus Puntos de Lealtad</h3>

            <div className="points-overview">
              <p>
                Tienes <strong>{user?.use_loyaltyPoints ?? 0}</strong> puntos
                acumulados.
              </p>

              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{
                    width: `${Math.min(
                      (user?.use_loyaltyPoints / 100) * 100,
                      100
                    )}%`,
                  }}
                />
              </div>
              <p className="progress-label">
                {user?.use_loyaltyPoints ?? 0} / 100 puntos
              </p>
            </div>

            <div className="redeem-options">
              <h4>Opciones de canje</h4>
              <button
                className="redeem-btn"
                disabled={
                  (user?.use_loyaltyPoints ?? 0) <
                  aux.aux_minimumLoyalPointsToRedeem
                }
                onClick={() =>
                  toggleModalRedeem(aux.aux_minimumLoyalPointsToRedeem)
                }
              >
                {loading
                  ? `Canjeando...`
                  : `Canjear ${aux.aux_minimumLoyalPointsToRedeem} puntos – ${aux.aux_loyalPointValue} €`}
              </button>
            </div>

            <p className="note">
              Los puntos se acreditan una vez que tus referidos realicen su
              primera recargas exitosa.
            </p>

            <button className="close-modal" onClick={() => setShowModal(false)}>
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Card informativa */}
      <div className="info-card">
        <FaInfoCircle className="icon" />
        <div className="content">
          <h3>¿Cómo funcionan los puntos?</h3>
          <p>
            Nuestro sistema de puntos te recompensa por cada envío que realizas.
            Cuantos más envíos hagas, más beneficios obtienes.
            <br />
            <br />
            <strong>Gana con cada envío:</strong> acumula puntos y canjéalos por
            euros en futuras remesas.
            <br />
            <strong>Invita y gana:</strong> comparte tu código de referido y
            obtén <strong>{aux.aux_referralBonusValue} €</strong> de regalo
            tanto para ti como para tu invitado.
            <br />
            <br />
            En RemesaEspana premiamos tu confianza y te acompañamos en cada
            envío.
          </p>
        </div>
      </div>

      {/* Lista de referidos */}
      <div className="referidos-list">
        <h3>Tus referidos</h3>
        <ul>
          {referralInfo?.length > 0 ? (
            referralInfo.map((r) => (
              <li key={r.use_name}>
                <span className="avatar">{r.use_name.charAt(0)}</span>
                <div className="info">
                  <strong>{r.use_name}</strong>
                  <small>ID: {r.use_referrerCode}</small>
                </div>
              </li>
            ))
          ) : (
            <li>No tienes referidos aún.</li>
          )}
        </ul>
      </div>

      {/* Botón final */}
      <div className="bottom-invite">
        <a
          className="invite-btn"
          href={`https://wa.me/?text=${encodeURIComponent(
            `¡Únete a la plataforma! Aquí tienes mi link de invitación: https://remesaespana.com/Register/${user?.use_referrerCode}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaUserPlus /> Invitar por WhatsApp
        </a>
      </div>

      <UserNavbar />
    </div>
  );
}

export { Referidos };
